// Outbound-UI Public API

export * from './lib/outbound-ui.module';

// Dashboard
export { OutboundDashboardComponent, LoadOutboundDashboard } from './lib/components/outbound-dashboard/outbound-dashboard.component';
export { LaunchBrandPipelineModalComponent } from './lib/components/outbound-dashboard/launch-brand-pipeline.modal';

// Sequence Builder
export { SequenceBuilderComponent, LoadSequenceBuilder } from './lib/components/sequence-builder/sequence-builder.component';

// Conduit — AIDP→Reply outbound UX (re-homed as a child component inside the
// Outbound Dashboard tab strip; NOT a standalone dashboard).
export { ConduitComponent, ConduitSection } from './lib/components/conduit/conduit.component';
export {
    ConduitActionClient,
    ConduitBinding,
    ConduitAudiencePreview,
    ConduitSampleContact,
    ConduitSaveViewResult,
    ConduitReconcileResult,
    ConduitSyncActivitiesResult,
    ConduitActivityRow,
    ConduitIntegrationHealth,
    ConduitHealthReport,
} from './lib/services/conduit-action.client';

// Action client (typed interface + GraphQL implementation)
export {
    OutboundActionClient,
    GraphQLOutboundActionClient,
    OutboundActionOutcome,
    OutboundReplyStats,
    OutboundEmailOverview,
    OutboundMeeting,
    OutboundSequence,
    OutboundCreateResult,
    OutboundUpdateResult,
    OutboundEnrollResult,
    OutboundEnrollPlan,
    BuilderStep,
    VoiceFinding,
    VoiceFindingSeverity,
    VoiceFindingWhere,
    GenerateOutboundCopyResult,
    LintSequenceCopyResult,
    CreateReplySequenceResult,
} from './lib/services/outbound-action.client';

// Loader imports
import { LoadOutboundDashboard } from './lib/components/outbound-dashboard/outbound-dashboard.component';
import { LoadSequenceBuilder } from './lib/components/sequence-builder/sequence-builder.component';

/**
 * Call this function in your MJ Explorer startup to ensure all Outbound UI
 * components and resources are loaded and registered (prevents tree-shaking from removing them).
 * Conduit is no longer a standalone dashboard — its screens live inside the
 * Outbound Dashboard's tab strip, so loading that dashboard is sufficient.
 */
export function LoadOutboundUI(): void {
    LoadOutboundDashboard();
    LoadSequenceBuilder();
}
